import { Bounce, ToastContainer } from "react-toastify";

const NotificationToastContainer = () => {
  return (
    <ToastContainer
      position="bottom-right"
      stacked
      autoClose={5000}
      pauseOnFocusLoss={false}
      pauseOnHover
      theme="dark"
      transition={Bounce}
      customProgressBar
      limit={5}
      closeButton={false}
      toastClassName="bg-[#2c2c2c] shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.3)]"
    />
  )
}

export default NotificationToastContainer;
